import React from 'react';
import { setCaretPosition } from './functions.js';


class TextEditorInput extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            content: this.props.contentLayer.content,
        };

        this.handleSelect = this.handleSelect.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);

        this.changeTimeout = null;
        this.changeTimeoutWait = 250;

    }

    componentDidUpdate() {
        if (this.state.content !== this.props.contentLayer.content)
        {
            this.setState({
                content: this.props.contentLayer.content,
            });
        }
    }

    getMaxCharsCount()
    {
        let count = 60;
        
        if (this.props.perspective.max_chars > 0)
            count = this.props.perspective.max_chars;
            
        if (this.props.activeDesignerVariants !== null && this.props.activeDesignerVariants !== undefined && this.props.activeDesignerVariants.length > 0)
        {
            for (var varI = 0; varI < this.props.activeDesignerVariants.length; varI++) {

                if (this.props.activeDesignerVariants[varI].selectedVar === null || this.props.activeDesignerVariants[varI].selectedVar === undefined)
                    continue;

                if (this.props.activeDesignerVariants[varI].selectedVar.max_chars > 0 && this.props.activeDesignerVariants[varI].selectedVar.max_chars < count)
                    count = this.props.activeDesignerVariants[varI].selectedVar.max_chars;
            }
        }

        return count;
    }

    handleTextChange(e) {
        e.preventDefault();

        if (e.target !== null && e.target !== undefined && 
            this.props.contentLayer.content != e.target.value &&
            e.target.value.length <= this.getMaxCharsCount())
        {
            const newLayer = this.props.contentLayer;
            newLayer.content = e.target.value;

            this.setState({
                content: newLayer.content,
            });

            // uplift changes after wait
            const self = this;
            if (self.changeTimeout !== null)
                clearTimeout(self.changeTimeout);

            self.changeTimeout = setTimeout(function(){
                self.props.onContentLayerChange(newLayer);
            }, self.changeTimeoutWait);
        }

        
    }

    handleSelect(e) {
        this.props.onPerspectiveLayerSelect(this.props.perspective, this.props.contentLayer);
    }

    render() {

        return (
            <input 
                className="text_editor_input" 
                type="text" 
                value={this.state.content} 
                onChange={this.handleTextChange}
                onClick={this.handleSelect}
            />
        );
    }
}
export default TextEditorInput;



// WEBPACK FOOTER //
// ./src/TextEditorInput.js